
import emitter from "../event/eventBus";
import Button from '../components/Button.vue';
import Title from '../components/Title.vue';
import { defineComponent, PropType, reactive, toRefs } from 'vue'
import { QuestionArray } from '../data/data';
export default defineComponent({
    components:{Button,Title},
    props:{
        question:{
            type:Object as PropType<QuestionArray>,
            default:() => ({
                question:"",
                answer:[],
                correct:""
            })
        }
    },
    setup(props){
        const state = reactive({
            question:props.question
        });
        const { correct } = props.question;
        const onSelectAnswer = (event:MouseEvent) => {
            const { target } = event;
            const { tagName } = target as HTMLElement;
            if((tagName as string).toLowerCase() === "button"){
                emitter.$emit("on-select-answer",() => ({
                    correct:correct,
                    answer:(target as HTMLButtonElement).textContent
                }));
            }
        }
        return {
            ...toRefs(state),
            onSelectAnswer
        }
    }
})
